module.exports = __webpack_public_path__ + "img/wizard_from_template.5f64526f.png";